// Phase P.11 — Shared date formatters for booking / invoice timestamps.
//
// `formatBookingStamp(iso)` renders "DD/MM HH:MM" (EU order, 24h clock).
// If the timestamp is older than ~12 months we append the year so an
// audit trail on a very old job doesn't collapse into "27/06 14:03" and
// look like it happened this year. Invalid / empty input returns "".

const TWELVE_MONTHS_MS = 365 * 24 * 60 * 60 * 1000;

function _pad(n) {
  return n < 10 ? `0${n}` : String(n);
}

export function formatBookingStamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const day = _pad(d.getDate());
  const month = _pad(d.getMonth() + 1);
  const hour = _pad(d.getHours());
  const min = _pad(d.getMinutes());
  const ageMs = Date.now() - d.getTime();
  if (ageMs > TWELVE_MONTHS_MS) {
    return `${day}/${month}/${d.getFullYear()} ${hour}:${min}`;
  }
  return `${day}/${month} ${hour}:${min}`;
}

// Compact relative helper used in the status-history timeline
// ("2m ago" / "3h ago" / "5d ago" / falls back to formatBookingStamp).
export function formatEventTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const diffMs = Date.now() - d.getTime();
  const diffMin = Math.round(diffMs / 60000);
  if (diffMin < 1) return "just now";
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  return formatBookingStamp(iso);
}
